import type React from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';
import type { TerritoryCode } from '~/lib/territories/territories';

export interface TerritoryCircleFlagProps
  extends React.HTMLAttributes<HTMLImageElement> {
  code: TerritoryCode;
  className?: string;
}

function TerritoryCircleFlag({
  code,
  className = '',
}: TerritoryCircleFlagProps) {
  const { t } = useTranslation('territories');

  return (
    <img
      src={`/images/flags/${code.toLowerCase()}.svg`}
      alt={t(`names.${code}`)}
      className={cn('size-[22px]', className)}
    />
  );
}

TerritoryCircleFlag.displayName = 'TerritoryCircleFlag';

export { TerritoryCircleFlag };
